import { useCallback, useEffect, useState } from "react";
import { getChallengesApi, celebrateChallengeApi } from "@/lib/api";
import { useProfile } from "@/context/ProfileContext";

/**
 * Stage 2.2: detect a freshly completed, joined challenge and surface its
 * celebration exactly once. The backend records the celebration the moment
 * it is shown, so it never re-appears after reloads or on other screens.
 */
export const useChallengeCelebration = () => {
  const { profile } = useProfile();
  const [celebration, setCelebration] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      try {
        const list = await getChallengesApi(profile.id);
        const pending = list.find((c) => c.celebration_pending);
        if (!pending || cancelled) return;
        // Mark as celebrated FIRST — guarantees the "once only" rule even if
        // the user closes the browser while the overlay is visible.
        await celebrateChallengeApi(pending.key, profile.id);
        if (!cancelled) setCelebration(pending);
      } catch {
        // Celebration is a bonus moment — never surface an error for it.
      }
    };
    check();
    return () => {
      cancelled = true;
    };
  }, [profile.id]);

  const dismiss = useCallback(() => setCelebration(null), []);

  return { celebration, dismiss };
};
